import eve from "../../Assets/event2.png";
import eve1 from "../../Assets/event1.png"
const eventsData = [
  {
    image: eve1,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "India",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "USA",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "USA",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "UK",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "UK",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "UK",
  },
  {
    image: eve1,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "India",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "India",
  },
  {
    image: eve1,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "India",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "India",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: " Canada",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "New Zealand",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "New Zealand",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "Singapore",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "Singapore",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "Singapore",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "Singapore",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "Singapore",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "Ireland",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "Germany",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "Venezeula",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "London",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "Vietnam",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "New York",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "New York",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "New York",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "New York",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "New York",
  },
  {
    image: eve,
    title: "Azent Overseas Education Online Fair - UK",
    date: "10th May 2021",
    venue: "Zoom meet | 02:00 PM",
    country: "Poland",
  },
];

export default eventsData;
